if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
        MediaUploadCheck,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/special-popup', {
        // built-in attributes
        title: 'Special Popup',
        description: 'Custom Special Popup',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: ''
            }, 
            affiliateLogo: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Find out more'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                backgroundImage,
                affiliateLogo,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };


            function onSelectAffiliateImage (image) {
                setAttributes({affiliateLogo: image.sizes.full.url});
            }

            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            function onRemoveImage (viewMore) {
                setAttributes({affiliateLogo: undefined});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Link' }>
                        <p><strong>Enter url: (ex: /vile-u-hrvatskoj)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                    </PanelBody>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ affiliateLogo } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                    </PanelBody>
                    <PanelBody title={ 'Logo Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectAffiliateImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Logo
                                </IconButton>
                            ) } />

                            { !! affiliateLogo &&
                                <MediaUploadCheck>
                                    <Button onClick={ onRemoveImage } isLink isDestructive>
                                        Remove Logo
                                    </Button>
                                </MediaUploadCheck>
                            }
                    </PanelBody>
                    <PanelBody title={ 'Popup Content' }>
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <p><strong>Description</strong></p>
                        <TextControl value={ description } onChange={ onDescriptionChange }></TextControl>
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div class="block-edit-popup">
                    <a class="row h-100">
                        <div class="col-lg-6 me-lg-n5 order-lg-0 order-1">
                            <div class="px-lg-5 px-3 py-lg-3 pt-2">
                                <div class="d-flex villsy-logo justify-content-lg-start justify-content-center">
                                        <img src="/wp-content/uploads/logo-text-gold.png" height="110" alt="Villsy" />
                                </div>
                            </div>

                            <div class="content">
                                <div class="px-lg-5 px-3">
                                    <div class="display-6 text-warning fw-bolder mt-lg-3 mt-2 headings-font-family">
                                        <RichText 
                                            key="editable" 
                                            tagName="h2" 
                                            class="title"
                                            placeholder="Title" 
                                            value={ title }
                                            onChange={ onTitleChange }
                                            style={ { color: '#fff' } } />
                                    </div>

                                    <div class="text-dark fs-2 mt-lg-4 mt-3 headings-font-family">
                                    <RichText 
                                        key="editable" 
                                        tagName="p" 
                                        class="description"
                                        placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit." 
                                        value={ description }
                                        onChange={ onDescriptionChange }
                                        style={ { color: '#fff' } } />
                                    </div>

                                    <div class="mt-lg-5 mt-3 mb-lg-0 mb-3">
                                        <div class="btn-select-date btn btn-warning fw-bolder fs-4 text-white text-uppercase py-lg-2 ">
                                            { viewMore }
                                        </div>
                                    </div>
                                </div> 
                        </div>

                        </div>
                        <div class="col cover-image order-0 image-overlay position-relative"  style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div class="d-flex justify-content-center my-3 ms-lg-5 ">
                                    <img class="" alt="Logo" height="70" src={ affiliateLogo } />
                                </div>
                        </div>
                    </a>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                backgroundImage,
                affiliateLogo,
                title,
                subtitle,
                description,
                viewMore
            } = attributes;

            return (
                <a class="row h-100" href={ link }>
                    <div class="col-lg-6 me-lg-n5 order-lg-0 order-1">
                        <div class="px-lg-5 px-3 py-lg-3 pt-2">
                               <div class="d-flex villsy-logo justify-content-lg-start justify-content-center">
                                    <img src="/wp-content/uploads/logo-text-gold.png" height="110" alt="Villsy" />
                               </div>
                        </div>

                        <div class="px-lg-5 px-3">
                            <div class="fs-2 text-warning fw-bolder mt-lg-3 mt-2 headings-font-family">
                                <RawHTML>
                                    { title }
                                </RawHTML>
                            </div>

                            <div class="text-dark fs-4 mt-lg-4 mt-3 headings-font-family">
                                <RawHTML>
                                    { description }
                                </RawHTML>
                            </div>

                            <div class="mt-lg-5 mt-3 mb-lg-0 mb-3">
                                <div class="btn-select-date btn btn-warning fw-bolder fs-5 text-white text-uppercase py-lg-2 ">
                                    { viewMore }
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col cover-image order-0 h-100 image-overlay position-relative lozad"  data-background-image={ backgroundImage }>
                            { affiliateLogo ? 
                            <div class="d-flex justify-content-center my-3 ms-lg-5 ">
                                <img class="" alt="Logo" height="70" src={ affiliateLogo } />
                            </div> : '' }
                            
                    </div>
                </a>
            );
        },
    });
}